import React, {Component} from "react";
import Cards from './Cards';
import axios from "axios";
import Footer from './Footer';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';
//import store from '../store';
import MessageBox from "./MessageBox";
import { connect } from 'react-redux';
import ItemCard2 from './ItemCard2';
import LeftFadeIn from "../components/animations/LeftFadeIn";
import RightFadeIn from "../components/animations/RightFadeIn";
import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";
import Typist from 'react-typist';


const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },

    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

    const api = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/adminuser/categoriesAPI/`
    })
    const Chatapi = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/chat/`
    })
    const recommendationApi = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/buyer/recommended/`
    })
    const GigApi = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/seller/`
    })
class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category : [],
            recommendations:[],
            search:'',
            unread:0,
            flag:false,
            trending:[],
        }
        this.getCategories(); 
        this.gettrending(); 
    }
    componentDidUpdate() {
        if(this.props.auth.user && this.state.flag === false) {
            this.getUnread()
            this.getRecommendations()
            this.setState({flag:true})
        }
      }
    
    handleSearch = (e) => {
        this.setState({search:e.target.value})
    }
    getCategories = async () => {
            let data = await api.get('/').then(({data})=>data);
            this.setState({category:data})
    }
    getUnread = async() => {
        let data = await Chatapi.get(`count/${this.props.auth.user.id}/`).then(({data})=>data);
        this.setState({unread:data.count});
        
    }
    getRecommendations = async() => {
        let data = await recommendationApi.get(`/${this.props.auth.user.id}/`).then(({data})=>data);
        data.map(async a=>
            this.get(a,data)
            )
    }
    get = async(a,data) => {
        let data1 = await GigApi.get(`Gig/${a.item}/`).then(({data})=>data)
        a.images = data1.images
        a.title = data1.title
        a.price = data1.price
        a.details = data1.details
        a.seller = data1.seller
        a.pid = data1.id
        a.average_rating = data1.average_rating
        this.setState({recommendations :data})
    }
    gettrending = async () => {
        let data = await GigApi.get(`TGigs/`).then(({data})=>data);
        this.setState({trending:data})
    }

    render() {
        const { auth } = this.props;
    return(
    <div style = {{backgroundColor: '#e0e0eb'}}>
        <div className='mt-5 video-background'>
            <video
                autoplay="true"
                muted="true"
                loop="true"
                src="/videos/home.mp4"
            />
            
            <div className='ms-5 pt-5 video-content' >
            <FadeIn>
                <div className='ms-5 pt-5' >
                    <h1 style={{fontFamily:'argentecf',fontSize: '50px'}}> We Provide <br />Architectural Design <br/> and Construction </h1>
                    <Typist cursor={{show: false}} avgTypingDelay={20}><h4>Create with the heart, Build with the mind.</h4></Typist>
                    <div className="input-group">
                        <div className="form-outline">
                            <input onChange={this.handleSearch}
                                type='text' name='search' className="form-control" placeholder='Search Here!' style={{width:'450px'}} />
                        </div>
                        <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/searched', 
                                    state:{search:this.state.search}
                                }}>
                        <button type="button" className="btn btn-primary">
                            <i className="fa fa-search"></i>
                        </button>
                        </Link>
                    </div>
                    <a href="/about" className="btn btn-primary about-us-home-btn" style={{marginTop: '50px'}}>Abous Us</a>
                </div>
            </FadeIn>
            </div>
        </div>
        <br/>
    {/*All Catagories in Cards*/}
        <LeftFadeIn>
            <div className='mt-3 ms-5'>
            <h1 className='mb-4' style={{fontFamily:'argentecf', color:'black'}}>Our Excellence Services</h1>
                <Carousel responsive={responsive}  >
                    {this.state.category.map((val) => {
                        return(
                            <div key={val.id}>
                                <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/items', 
                                    state:{
                                        categoryID:val.id,
                                        categoryName: val.name
                                    }
                                }}>
                                <Cards imgsrc={val.image_url} title={val.name} sname ={val.description}/>
                                </Link>
                            </div>
                        );
                    })}
                </Carousel>
            </div>
        </LeftFadeIn>
        <br/><br/>
        <RightFadeIn>
            <div className='mt-3 ms-5'>
            <h1 className='mb-4' style={{fontFamily:'argentecf', color:'black'}}>Products</h1>
            <Carousel responsive={responsive} >
                {this.state.trending.map(a =>  
                    <div className="col mb-4" key={a.id}>    
                        <ItemCard2 images={a.images} title={a.title} price ={a.price} details={a.details} seller={a.seller} itemID={a.id} rating={a.average_rating} />
                    </div>
                )}
            </Carousel>
            </div>
        </RightFadeIn>
        <br/>
        
        <SlideIn>
            <div className='mt-3 w3-light-gray'>
            <div className='row ms-5'>
                <div className="col-sm">
                    <br/><br/><br/>
                    <h1 style={{fontFamily:'Cursive', fontSize: '18px'}}><Typist startDelay={1000} cursor={{hideWhenDone: true}} avgTypingDelay={20}>More than 100 building and housing project that we have built. The building ownwer choose us over other contractors because our work is different.</Typist></h1><br/>
                    <h4><i className='fa fa-check-circle'/> The best for every budget</h4>
                    <p>Find high-quality services at every price point.<br/> No hourly rates, just project-based pricing.</p>
                    
                    <h4><i className='fa fa-check-circle'/> Quality work done quickly</h4>
                    <p>Find the right Seller to begin working on your <br/>project within minutes.</p>

                    <h4><i className='fa fa-check-circle'/> 24/7 support</h4>
                    <p>Questions? Our round-the-clock support team is<br/> available to help anytime, anywhere.</p>
                </div>
                <div className="col-sm mt-4">
                    <br/>
                    <img src="/images/pexels-tima-miroshnichenko-6195288.jpg" style={{height:420, width:520, paddingBottom: 10, marginLeft: 65}} className="rounded float-start mt-5" alt="..."/>
                </div>
            </div>
            </div>
        </SlideIn>
        <hr />
        
        <Footer />
        
    </div>
    )}
    }

const mapStateToProps = state => ({
    auth: state.auth
});
    
export default connect(mapStateToProps, { })(Home);
